export default __webpack_public_path__ + "static/media/sailing_boat_rest_bay_st_john_virgin_islands.2fe19351.webp";